import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
// Import the NumericOnlyDirective
import { NumericOnlyDirective } from '../../sharedComponents/directives';
import { OperatorService } from '../../../services/operator.service';
import { finalize } from 'rxjs';
import { TLRDataModel } from '../../../models/tlrDataModel';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { SpinnerComponent } from '../../sharedComponents/spinner/spinner.component';
import { NotificationService } from '../../../services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../services/storage.service';
import { CommonService } from '../../../services/common.service';

@Component({
    selector: 'app-operation-create-new-tlr-repump',
    imports: [
        CommonModule,
        FormsModule,
        RadioButtonModule,
        InputTextModule,
        TableModule,
        ButtonModule,
        // Add the directive to imports
        NumericOnlyDirective,
        SpinnerComponent
    ],
    templateUrl: './operation-create-new-tlr-repump.component.html',
    styleUrl: './operation-create-new-tlr-repump.component.scss'
})
export class OperationCreateNewTlrRepumpComponent implements OnInit {

  constructor(private operatorService: OperatorService, private sanitizer: DomSanitizer,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService) { 
      this.fecilityId = this.commonService.getCurrentFacilityId()
    }

  isLoading: boolean = false;
  tagNumber: string = '';
  selectedOption: string = 'Pre-Installation';
  showRepumpDetails: boolean = false;
  showEditDetails: boolean = false;
  showMaximoDetails: boolean = false;
  repumpCount: number = 0;
  tlrData: TLRDataModel | null = null;
  operatorMessage!: SafeHtml;
  showRepumpValidationMessage: boolean = false;
  showMessage: boolean = false;
  returnCode!: number;
  tlrStatus!: string;
  fecilityId: string = ''; // Default facility ID
  disableTagInput: boolean = false; // Flag to disable tag input field
  dCai!: string; // Default value for deCai
  targetSection!: string;
  dropdownList!: any;
  drpTechnicalJust!: string;
  selectedServices: boolean[] = [];
  action: string = 'new';
  showDefaultMessage: boolean = false;
  repumpNotAllowed: boolean = false;
  validMaximoRecord: boolean = false;
  currentAction: string = 'new';
  repumpComments: string = '';
  showOtherJustification: boolean = false;
  othertechJustification: string = '';
  editMessage: boolean = false;
  showRadioButtons: boolean = true; // Flag to show/hide radio buttons

  // Technical Justification options
  technicalJustificationOptions = [
    {
      value: '1',
      text: 'Performing a TLR would allow for continued safe operation and prevent the LPO associated with shutting down the unit. A Permanent repair will be implemented during the next available maintenance opportunity.'
    },
    {
      value: '2',
      text: 'Other (Please provide Technical Justification below)'
    }
  ];

  tlrObject: TLRDataModel = {
    tag_number: '',
    repair_type_name: '',
    section_name: '',
    leaking_name: '',
    plant_name: '',
    material_state_name: '',
    division_name: '',
    de_date_entered: '',
    de_cai: '',
    rule_1173: '',
    operating_PSI: '',
    operating_temperature: '',
    operator_comments: '',
    leaking_other: '',
    service_other: '',
    tlr_status: '',
    data_found_in_passport: '',
    assoc_plant_shutdown: '',
    shutdown_description: '',
    mx_facility: '',
    mx_division: '',
    mx_unit: '',
    mx_refnum: '',
    mx_tlr_description: '',
    mx_description: '',
    mx_wonum: '',
    mx_wo_status: '',
    mx_wo_status_date: '',
    mx_planner: '',
    mx_reportedby: '',
    mx_reportdate: '',
    mx_needbydate: '',
    mx_worklocation: '',
    mx_assetnum: '',
    mx_legacyid: '',
    mx_worktype: '',
    mx_wopriority: '',
    mx_compbydate: '',
    mx_outage: '',
    rePumpCounter: 0,
    permRepairComplete: '0',
    technicalJustification: '',
    service_list: '',
    returnCode: 0
  }


  OperatorMessage = {
    tlrRequired: '<span class="MessageTitle">TLR Repaired: </span>This TLR has been repaired. No repumps are allowed.',
    tagExistsMessage: '<span class="MessageTitle">Success - TLR Record Found</span> Before continuing, are you sure the tag number is correct and the facility is correct.  If not, please click "Start Over" Or "Cancel".<br /><br />If everything seems correct, you will be able to review the Passport/Maximo data that has been retrieved.',
    tagNotValidMessage: 'This tag number already exists in the TLR system.  Are you sure the tag and facility are correct?  If not, please click "Start Over" If everything seems correct, you agree that this is a repump by clicking "Continue" to continue.',
    newRepumpMessage: 'This is the NEW repump. Repump count: .',
    tagNotValidMessage3: 'TAG NUMBER: Please enter 5 digits and leading zeros if necessary.',
    maximoMessage: '<span class="MessageTitle">Maximo Connection Successful - Data Found</span> Connecting to Maximo was successful.  Information from Maximo has been found.  You may continue to submit your TLR entry.',
  };

  ngOnInit(): void {
    // Subscribe to route params to get action and tagNumber
    this.route.params.subscribe(params => {
      if (params['a']) {
        this.action = params['a'];
      }
      if (params['tagNumber']) {
        this.tagNumber = params['tagNumber'];
      }
    });
    
    if (this.action === 'new') {
      this.showDefaultMessage = true;
    }
    if (this.action === 'update') {
      this.editMessage = true;
      this.showRadioButtons = false;
      this.selectedOption = 'Edit';
      this.showValidateButton = false;
      this.showStartOverButton = false;
      this.disableTagInput = true;
      this.showMaximoDetails = true;
      this.showEditDetails = true;
      this.showRepumpDetails = false;
      this.tagNumber = this.tagNumber || this.getTagNumber();
      // Load dropdown list first, then update TLR data
      this.loadDropdownAndUpdateData();
    }
    if (this.action === 'repump') {
      this.showValidateButton = false;
      this.showStartOverButton = false;
      this.disableTagInput = true;
      this.showRadioButtons = false;
      this.editMessage = true;
      this.selectedOption = 'Repump';
      this.getRepumpCounter();
      this.showRepumpDetails = true;
      this.getTLRDataForRepump();
      this.updateRepump();
    }
  }

  // Add missing properties needed by the HTML template
  showTagValidationMessage: boolean = false;
  tagExistsMessage: string = '';
  showStartOver: boolean = false; // New flag to control Start Over button visibility
  showRepumpDetailsContainer: boolean = false; // Flag for repump-details-container

  // Button visibility flags
  showValidateButton: boolean = true;
  showContinueButton: boolean = false;
  showStartOverButton: boolean = false;
  showCancelButton: boolean = true; // Always visible by default

  updateTLRData() {
    this.operatorService.getOperatorTLRData(this.tagNumber)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.tlrData = data;
            
            // Handle date properly - check if it's already a Date or string
            if (data.de_date_entered) {
              if (data.de_date_entered instanceof Date) {
                this.tlrObject.de_date_entered = data.de_date_entered.toISOString();
              } else if (typeof data.de_date_entered === 'string') {
                this.tlrObject.de_date_entered = new Date(data.de_date_entered).toISOString();
              } else {
                this.tlrObject.de_date_entered = new Date().toISOString();
              }
            } else {
              this.tlrObject.de_date_entered = new Date().toISOString();
            }
            
            this.tlrObject.tag_number = this.tagNumber;
            this.tlrObject.repair_type_name = data.repair_type_name || '';
            this.tlrObject.section_name = data.section_name || '';
            this.tlrObject.leaking_name = data.leaking_name || '';
            this.tlrObject.plant_name = data.plant_name || '';
            this.tlrObject.material_state_name = data.material_state_name || '';
            this.tlrObject.division_name = data.division_name || '';
            this.tlrObject.de_cai = data.de_cai || '';
            this.tlrObject.rule_1173 = data.rule_1173 || '';
            this.tlrObject.operating_PSI = data.operating_PSI || '';
            this.tlrObject.operating_temperature = data.operating_temperature || '';
            this.tlrObject.operator_comments = data.operator_comments || '';
            this.tlrObject.leaking_other = data.leaking_other || '';
            this.tlrObject.service_other = data.service_other || '';
            this.tlrObject.tlr_status = data.tlr_status || '';
            this.tlrObject.assoc_plant_shutdown = data.assoc_plant_shutdown || '';
            this.tlrObject.shutdown_description = data.shutdown_description || '';
            this.tlrObject.service_list = data.service_list || '';
            this.tlrObject.permRepairComplete = data.permRepairComplete || '0';
            this.tlrObject.technicalJustification = data.technicalJustification || '';
            this.tlrObject.rePumpCounter = data.rePumpCounter || 0;
            this.tlrObject.returnCode = data.returnCode || 0;

            // Handle technical justification - if value exists but not in dropdown, set to "Other"
            if (this.tlrObject.technicalJustification && this.dropdownList) {
              const justificationExists = this.tlrObject.technicalJustification === '1' || this.tlrObject.technicalJustification === '2';
              if (!justificationExists) {
                 this.othertechJustification = this.tlrObject.technicalJustification;
                this.tlrObject.technicalJustification = '2';
                this.showOtherJustification = true; // Show the textbox
              }
              else {
                this.showOtherJustification = false; // Hide the textbox
              }
            }
            
            // Populate selected services if data exists and dropdown is loaded
            if (this.dropdownList?.services) {
              this.populateSelectedServices(data.service_list);
            }
            
            // Force change detection to ensure UI updates
            this.cdr.detectChanges();
            
          }
        },
        error: (error: any) => {
          console.error('Error fetching TLR data for update:', error);
          this.isLoading = false;
        }
      });
  }

  updateRepump() {
    this.currentAction = 'Repump';
    this.operatorService.getRepumpCounter(this.tagNumber)
      .subscribe((data: any) => {
        if (Array.isArray(data) && data.length === 0) {
          this.repumpCount = 0;
        } else if (typeof data === 'number') {
          this.repumpCount = data;
        } else if (data && typeof data.repumpCounter === 'number') {
          this.repumpCount = data.repumpCounter;
        } else {
          this.repumpCount = 0;
        }
        this.repumpCount = this.repumpCount + 1;
      });
  }

  validateTag() {
    if (!this.tagNumber || this.tagNumber.length < 5) {
      this.notificationService.showError('Please enter a valid tag number with at least 5 digits.');
      return;
    }
    if (this.tagNumber && !this.disableTagInput) {
      if (this.selectedOption === 'edit' || this.selectedOption === 'Pre-Installation') {

        this.operatorService.getOperatorTLRData(this.tagNumber)
          .pipe(
            finalize(() => {
              this.isLoading = false;
            })
          )
          .subscribe({
            next: (data: any) => {
              if (data) {
                this.tlrData = data;
                this.returnCode = data.returnCode;
                this.showContinueButton = true;
                this.showStartOverButton = true;
                this.showValidateButton = false;
                this.disableTagInput = true;
                this.showTagValidationMessage = false;
                switch (data.returnCode) {
                  case 0: {
                    if (data.tlr_status === 'R') {
                      //this.selectedOption = 'Repump';
                      this.showContinueButton = false;
                      this.showStartOverButton = true;
                      this.showValidateButton = false;
                      this.repumpNotAllowed = true;
                      this.disableTagInput = true;

                      this.showMaximoDetails = false;
                      this.showEditDetails = false;
                      this.showRepumpDetails = false;

                      this.showRepumpValidationMessage = false;
                      this.showTagValidationMessage = false;
                      this.showRepumpDetails = false;
                      this.showDefaultMessage = false;
                    }
                    else if (this.tlrData && this.tlrData.de_cai !== 'XXXX') {
                      //this.operatorMessage = this.sanitizer.bypassSecurityTrustHtml(this.OperatorMessage.tagNotValidMessage);
                      //this.showTagValidationMessage = true;
                      this.showContinueButton = true;
                      this.showStartOverButton = true;
                      this.showValidateButton = false;
                      this.disableTagInput = true;
                      if (this.selectedOption === 'Pre-Installation') {
                        this.selectedOption = 'Repump';
                      }
                      this.currentAction = 'Repump';
                      this.operatorService.getRepumpCounter(this.tagNumber)
                        .subscribe((data: any) => {
                          if (Array.isArray(data) && data.length === 0) {
                            this.repumpCount = 0;
                          } else if (typeof data === 'number') {
                            this.repumpCount = data;
                          } else if (data && typeof data.repumpCounter === 'number') {
                            this.repumpCount = data.repumpCounter;
                          } else {
                            this.repumpCount = 0;
                          }
                          this.repumpCount = this.repumpCount + 1;
                          this.showRepumpValidationMessage = true;
                          this.showTagValidationMessage = true;
                          this.showDefaultMessage = false;
                        });
                    }
                    else if (this.tlrData && this.tlrData.de_cai === 'XXXX') {
                      this.operatorMessage = this.OperatorMessage.tagExistsMessage;
                      this.showContinueButton = true;
                      this.showStartOverButton = true;
                      this.showValidateButton = false;
                      this.disableTagInput = true;
                    }
                    else {
                      this.showContinueButton = false;
                      this.showStartOverButton = true;
                      this.showValidateButton = false;
                    }
                    break;
                  }
                  case 101: {
                    if (data.tlr_status === 'R') {
                      this.operatorMessage = this.sanitizer.bypassSecurityTrustHtml(this.OperatorMessage.tlrRequired);
                      this.showContinueButton = false;
                      this.showStartOverButton = true;
                      this.showValidateButton = false;
                      this.disableTagInput = true;
                      this.targetSection = 'Repump';
                    } else {
                      this.operatorMessage = this.sanitizer.bypassSecurityTrustHtml(this.OperatorMessage.maximoMessage);
                      this.showContinueButton = true;
                      this.showStartOverButton = true;
                      this.showValidateButton = false;
                      this.disableTagInput = true;
                    }
                    break;
                  }
                  case -202: {
                    this.validMaximoRecord = true;
                    this.showDefaultMessage = true;
                    this.showValidateButton = false;
                    this.showContinueButton = true;
                    this.showStartOverButton = true;
                    this.showValidateButton = false;
                    this.disableTagInput = true;
                    this.currentAction = 'new';
                    break;
                  }
                  default: {
                    this.targetSection = 'Other';
                    this.showMessage = true;
                  }
                }
              }
            },
            error: (error: any) => {
              console.error('Error fetching inspection data:', error);
            }
          });
      }
      else if (this.selectedOption === 'Repump') {
        this.getRepumpCounter();
        if (this.repumpCount > 0) {
          this.selectedOption = 'Repump';
          this.operatorMessage = this.sanitizer.bypassSecurityTrustHtml(this.OperatorMessage.newRepumpMessage);
          this.repumpCount += 1;
          this.showStartOverButton = false;
          this.showValidateButton = false;
          this.showContinueButton = false;
          this.showRepumpDetails = true;
        }

      }
      else {
        this.operatorMessage = this.sanitizer.bypassSecurityTrustHtml(this.OperatorMessage.tagNotValidMessage3);
        this.showContinueButton = false;
        this.showStartOverButton = true;
        this.showValidateButton = false;
      }

      this.showValidateButton = true;
      return;
    }
  }

  // Add missing methods needed by the HTML template
  continue() {
    if (this.currentAction === 'Repump') {
      this.showMaximoDetails = true;
      this.showEditDetails = false;
      this.showRepumpDetails = true;
      this.showContinueButton = false;
    }

    
    else if (this.targetSection === 'edit') {
      this.showMaximoDetails = true;
      this.showEditDetails = true;
      this.showContinueButton = false;
      this.showValidateButton = false;
      this.showStartOverButton = true;
    } else if (this.currentAction === 'Maximo') {
      this.showMaximoDetails = true;
      this.showEditDetails = true;
      this.showContinueButton = false;
      this.showValidateButton = false;
      this.showStartOverButton = true;
      this.showCancelButton = true;
      this.showMessage = false;
      this.getDropdownList();
    } else {
      this.getDropdownList();
      this.showEditDetails = true;
      this.showMaximoDetails = true;
      this.showContinueButton = false;
      this.tlrObject.de_date_entered = new Date().toISOString();

      this.selectedOption = 'Pre-Installation';
      this.tlrObject.repair_type_name = 'TLR';
      this.tlrObject.rule_1173 = 'equipmentIntegrity';
      this.tlrObject.tag_number = this.tagNumber;
    }
    return;
  }

  startOver() {
    this.resetForm();
  }
  submitRepump() {
    this.isLoading = true;
    const currentUser = sessionStorage.getItem('currentUser') || '';
    const repumpData = {
      facilityId: this.fecilityId,
      tagNumber: this.tagNumber,
      cai: currentUser || this.dCai,
      repumpComments: this.repumpComments ?? ''
    };

    this.operatorService.updateRepumpCounter(repumpData)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: (data: any) => {
          // Handle both string and object responses
          let responseMessage = '';
          if (typeof data === 'string') {
            responseMessage = data;
          }
          // Check for success indicators in the response
          if (responseMessage &&
            responseMessage.toLowerCase().includes('success')
          ) {
            this.notificationService.showSuccess('Repump counter updated successfully!');
            this.resetForm();
          } else {
            // If response doesn't indicate success, treat as error
            this.notificationService.showError('Unexpected response from server: ' + responseMessage);
          }
        },
        error: (error: any) => {
          console.error('Error updating repump counter:', error);
          let errorMessage = 'Failed to update repump counter.';

          // Extract meaningful error message
          if (error.error && typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.message) {
            errorMessage = error.message;
          } else if (error.status) {
            errorMessage = `Server error (${error.status}): ${error.statusText || 'Unknown error'}`;
          }

          this.notificationService.showError(errorMessage);
        }
      });
  }

  resetForm() {
    this.tagNumber = '';
    this.showMessage = true;
    this.selectedOption = 'Pre-Installation';
    this.showTagValidationMessage = false;
    this.showMaximoDetails = false;
    this.showEditDetails = false;
    this.showRepumpDetails = false;

    this.showStartOverButton = false;
    this.disableTagInput = false;
    this.showCancelButton = false;
    this.showContinueButton = false;
    this.showValidateButton = true;

    this.showRepumpValidationMessage = false;
    this.validMaximoRecord = false;
    this.repumpNotAllowed = false;
    this.showDefaultMessage = true;
    this.repumpCount = 0;
  }

  cancel() {
    this.resetForm();
    this.router.navigate(['/app-operation-overview']);
  }

  rdNewTLR() {
    this.resetForm();
    this.selectedOption = 'Pre-Installation';
    this.showMessage = true;
  }

  rdRepump() {
    this.selectedOption = 'Repump';
    this.showMessage = false;
  }

  getTLRData() {
    this.isLoading = true;
    this.operatorService.getOperatorTLRData(this.tagNumber)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.tlrData = data;
            this.returnCode = data.returnCode;
            this.tlrStatus = data.tlr_status;
            this.dCai = data.deCai;
            this.operatorMessage = this.OperatorMessage.tagExistsMessage.replace('${this.tagNumber}', this.tagNumber);
            this.showContinueButton = true;
            this.showStartOverButton = true;
            this.showValidateButton = false;
            this.disableTagInput = true;
            this.repumpComments = data.operator_comments || '';
          }
        },
        error: (error: any) => {
          console.error('Error fetching inspection data:', error);
        }
      });
  }

  getRepumpCounter(): any {
    this.isLoading = true;
    this.operatorService.getRepumpCounter(this.tagNumber)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.repumpCount = data.repumpCounter;
            return data.repumpCounter ?? 0;
          }
        },
        error: (error: any) => {
          console.error('Error fetching TLR data:', error);
        }
      });
  }

  UpdateRepumpCount() {
    this.isLoading = true;
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const repumpData = {
      facilityId: this.fecilityId,
      tagNumber: this.tagNumber,
      cai: currentUser.cai || this.dCai,
      repumpComments: this.tlrData!.operator_comments ?? ''
    };
    this.operatorService.updateRepumpCounter(repumpData)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          this.notificationService.showSuccess('Repump counter updated successfully!');
        },
        error: (error: any) => {
          this.notificationService.showError('Failed to update repump counter.');
          console.error('Error updating repump counter:', error);
        }
      });
  }
  getDropdownList() {
    this.isLoading = true;
    this.operatorService.getDropdonwList()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.dropdownList = data;
            this.initializeTLRObjectWithDropdownData();
          }
        },
        error: (error: any) => {
          console.error('Error fetching TLR data:', error);
        }
      });
  }

  initializeTLRObjectWithDropdownData() {
    if (this.dropdownList) {
      if (this.dropdownList.Division && this.dropdownList.division.length > 0) { //IGP
        this.tlrObject.division_name = this.dropdownList.division[0].division_name;
      }
      if (this.dropdownList.Section && this.dropdownList.section.length > 0) { //IGP
        this.tlrObject.plant_name = this.dropdownList.section[0].section_name;
      }
      if (this.dropdownList.repairTypes && this.dropdownList.repairTypes.length > 0 && !this.tlrObject.repair_type_name) {
        this.tlrObject.repair_type_name = this.dropdownList.repairTypes[0];
      }
      if (this.dropdownList.plants && this.dropdownList.plants.length > 0) {
        this.tlrObject.plant_name = this.dropdownList.plants[0].plantName;
      }
      if (this.dropdownList.shutdown && this.dropdownList.shutdown.length > 0) {
        this.tlrObject.shutdown_description = this.dropdownList.shutdown[0];
      }
      if (this.dropdownList.materialStates && this.dropdownList.materialStates.length > 0) {
        this.tlrObject.material_state_name = this.dropdownList.materialStates[0];
      }
      if (this.dropdownList.services && this.dropdownList.services.length > 0) {
        // Initialize selectedServices array with the same length as services array
        this.selectedServices = new Array(this.dropdownList.services.length).fill(false);
      }
    }
  }

  addOrUpdateTLRData() {
    if (this.selectedOption === 'Edit') {
      this.returnCode = 0;
    }
    switch (this.returnCode) {
      case 0: {
        this.saveTLRData(1);
        break;
      }
      case 101: {
        this.saveTLRData(1);
        break;
      }
      case -202: {
        this.saveTLRData(0);
        break;
      }
      default: {
        //this.showDefaultMessage = true;
      }
    }
  }
  saveTLRData(saveOrEdit: number) {
    if (this.validateTLRObject()) {
      this.tlrObject.tag_number = this.tagNumber;
      this.tlrObject.service_list = this.updateOperationService();
      this.tlrObject.mx_facility = this.fecilityId;
      this.tlrObject.de_cai = sessionStorage.getItem('currentUser') || ''; this.tlrObject.operating_PSI = this.tlrObject.operating_PSI === '' ? '0' : this.tlrObject.operating_PSI;
      this.tlrObject.operating_temperature = this.tlrObject.operating_temperature === '' ? '0' : this.tlrObject.operating_temperature;
      this.tlrObject.technicalJustification = this.tlrObject.technicalJustification === '2' ? this.othertechJustification : this.tlrObject.technicalJustification;

      this.isLoading = true;

      if (saveOrEdit === 1) {
        this.operatorService.updateTLRData(this.tlrObject)
          .pipe(
            finalize(() => {
              this.isLoading = false;
            })
          ).subscribe({
            next: (data: any) => {
              // Handle text response from API
              if (data && (data.includes('successfully') || data.includes('Success'))) {
                this.notificationService.showSuccess('TLR data updated successfully!');
              } else {
                this.notificationService.showSuccess('TLR data updated successfully!');
              }
            },
            error: (error: any) => {
              this.notificationService.showError('Failed to update TLR data.');
              console.error('Error updating TLR data:', error);
            }
          });
      }
      else if (saveOrEdit === 0) {
        this.tlrObject.tlr_status = 'P';
        this.operatorService.addTLRData(this.tlrObject)
          .pipe(
            finalize(() => {
              this.isLoading = false;
            })
          ).subscribe({
            next: (data: any) => {
              // Handle text response from API
              if (data && (data.includes('successfully') || data.includes('Success'))) {
                this.notificationService.showSuccess('RePumpCounter updated and record inserted successfully.');
                this.router.navigate(['/app-operation-overview']);
              }
            },
            error: (error: any) => {
              this.notificationService.showError('Failed to save TLR data.');
              console.error('Error saving TLR data:', error);
            }
          });
      }
    }
  }

  updateOperationService() {
    return this.dropdownList.services
      .filter((_: any, i: number) => this.selectedServices[i])
      .join('|');
  }

  openFileInNewTab(fileName: string): boolean | void {
    this.storageService.downloadFile(fileName);
  }
  onJustificationChange(event: any) {
    let value = event.target.value;
    if (value == 2) {
      this.showOtherJustification = true;
    }
    else {
      this.showOtherJustification = false;
    }
  }

  onPermRepairCompleteChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.tlrObject.permRepairComplete = checkbox.checked ? '1' : '0';
  }

  validateTLRObject(): boolean {
    console.log('rules 1137: ', this.tlrObject.rule_1173);
    if (!this.tlrObject.tag_number) {
      this.notificationService.showError('Tag number is required.');
      return false;
    }
    if (!this.tlrObject.repair_type_name) {
      this.notificationService.showError('Repair type is required.');
      return false;
    }
    if (isNaN(Number(this.tlrObject.operating_PSI))) {
      this.notificationService.showError('Operating PSI must be a number.');
      return false;
    }
    if (isNaN(Number(this.tlrObject.operating_temperature))) {
      this.notificationService.showError('Operating temperature must be a number.');
      return false;
    }
    if (!this.tlrObject.operator_comments) {
      this.notificationService.showError('Operator comments are required.');
      return false;
    }
    if (this.selectedServices.length === 0 || !this.updateOperationService()) {
      this.notificationService.showError('At least one service must be selected.');
      return false;
    }
    if (!this.tlrObject.technicalJustification) {
      this.notificationService.showError('Technical justification is required.');
      return false;
    }
    if (!this.tlrObject.rule_1173) {
      this.notificationService.showError('Rule_1173 is required.');
      return false;
    }

    return true; // All validations passed
  }

  getTLRDataForRepump() {
    this.isLoading = true;
    this.operatorService.getOperatorTLRData(this.tagNumber)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.tlrData = data;
          }
        },
        error: (error: any) => {
          console.error('Error fetching inspection data:', error);
        }
      });
  }
  getTagNumber(): string {
    let retrievedTagNumber = '';
    this.route.params.subscribe(params => {
      if (params['tagNumber']) {
        retrievedTagNumber = params['tagNumber'];
        this.tagNumber = retrievedTagNumber;
      }
    });
    return retrievedTagNumber || this.tagNumber || '';
  }

  populateSelectedServices(serviceList: string) {
    if (serviceList && this.dropdownList?.services) {
      const existingServices = serviceList.split('|').filter(service => service.trim() !== '');
      this.selectedServices = this.dropdownList.services.map((service: string) =>
        existingServices.includes(service)
      );
    } else if (serviceList && !this.dropdownList?.services) {
      console.warn('Dropdown list not loaded yet, services will be populated later');
    } 
  }

  loadDropdownAndUpdateData() {
    this.isLoading = true;
    this.operatorService.getDropdonwList()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.dropdownList = data;
            
            // Initialize selected services array first
            if (this.dropdownList.services && this.dropdownList.services.length > 0) {
              this.selectedServices = new Array(this.dropdownList.services.length).fill(false);
            }
            
            // Then update TLR data which will populate the services
            this.updateTLRData();
          }
        },
        error: (error: any) => {
          console.error('Error fetching dropdown data:', error);
          this.isLoading = false;
        }
      });
  }

  // Helper method to get technical justification text by value
  getTechnicalJustificationText(value: string): string {
    const option = this.technicalJustificationOptions.find(opt => opt.value === value);
    return option ? option.text : value || '';
  }
}
